import { render, staticRenderFns } from "./McustomerCreate.vue?vue&type=template&id=42230afa"
import script from "./McustomerCreate.vue?vue&type=script&lang=js"
export * from "./McustomerCreate.vue?vue&type=script&lang=js"
import style0 from "./McustomerCreate.vue?vue&type=style&index=0&id=42230afa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports